<template>
    <EChart :options="chartData" card :header="$t('averagePriceInTime')" :loading="request.getLoading()" />
</template>



<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'AveragePriceInTime',
        components: {
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestData1,
            };
        },
        computed: {
            data() {
                return this.parentComponent.data;
            },
            chartData() {
                if (!this.data?.length) return { series: [] };

                const storeDataMap = {};

                this.data.forEach(product => {
                    const { report } = product;
                    if (!report) return;
                    Object.entries(report).forEach(([store, storeReport]) => {
                        if (!storeReport.chart || storeReport.chart.length === 0) return;
                        storeReport.chart.forEach(({ date, avg }) => {
                            if (avg === null) return;
                            if (!storeDataMap[store]) {
                                storeDataMap[store] = {};
                            }
                            // Grupujemy dane po dacie
                            if (!storeDataMap[store][date]) {
                                storeDataMap[store][date] = [];
                            }
                            storeDataMap[store][date].push(avg);
                        });
                    });
                });

                // Dla każdego sklepu tworzymy tablicę punktów: [timestamp, computedAverage]
                const series = Object.entries(storeDataMap).map(([store, dateMap]) => {
                    const dataPoints = Object.entries(dateMap).map(([date, avgValues]) => {
                        const computedAvg = avgValues.reduce((sum, value) => sum + value, 0) / avgValues.length;
                        return [Number(date), computedAvg];
                    });
                    // Sortujemy punkty rosnąco wg daty
                    dataPoints.sort((a, b) => a[0] - b[0]);
                    return {
                        name: store,
                        type: 'line',
                        areaStyle: null,
                        data: dataPoints,
                    };
                });

                return {
                    tooltip: {
                        trigger: 'axis',
                        valueFormatter: value => this.$format.currency(value),
                    },
                    xAxis: {
                        type: 'time',
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series,
                };
            },
        },
    };
</script>
